/**
 * Logger Utility for THE ONESCENT DIAL
 * 
 * Provides conditional logging that can be disabled in production.
 * Usage: import { logger } from '../utils/logger';
 *        logger.log('message');
 *        logger.warn('warning');
 *        logger.error('error');
 * 
 * © Optimal Mastery LLC and the Onesce family of applied wellness brands.
 */

const IS_DEV = process.env.NODE_ENV === 'development';
const DEBUG_ENABLED = process.env.REACT_APP_DEBUG === 'true' || IS_DEV;

export const logger = {
  log: (...args) => {
    if (DEBUG_ENABLED) {
      console.log('[TOD]', ...args);
    }
  },
  
  warn: (...args) => {
    // Warnings are always logged as they indicate potential issues
    console.warn('[TOD]', ...args);
  },
  
  error: (...args) => {
    // Errors are always logged for debugging
    console.error('[TOD]', ...args);
  },
  
  debug: (...args) => {
    if (DEBUG_ENABLED) {
      console.debug('[TOD]', ...args);
    }
  },
  
  // Group logging for complex operations
  group: (label) => {
    if (DEBUG_ENABLED) {
      console.group(`[TOD] ${label}`);
    }
  },
  
  groupEnd: () => {
    if (DEBUG_ENABLED) {
      console.groupEnd();
    }
  },
  
  // Table logging for data structures
  table: (data) => {
    if (DEBUG_ENABLED) {
      console.table(data);
    }
  }
};

// For components that need auth-specific logging
export const authLogger = {
  log: (...args) => {
    if (DEBUG_ENABLED) {
      console.log('[Auth]', ...args);
    }
  },
  warn: (...args) => console.warn('[Auth]', ...args),
  error: (...args) => console.error('[Auth]', ...args)
};

export default logger;
